import React, { useState } from 'react';

import { UiComponent } from 'components';
import { usePageOption } from 'hooks';
import { CollectionQuery } from 'queries';
import { ICollection, SearchCollectionsFilterType } from 'types';
import { theme } from 'styles';
import { COLLECTION_TYPE_LABEL } from './constants';

const { color, radius } = theme;

interface Props {
  collectionIds: number[];
  handleSelect: (collection: ICollection) => void;
}

function CollectionModal({ collectionIds, handleSelect }: Props) {
  const { pageOption } = usePageOption();
  const [filter] = useState<SearchCollectionsFilterType>({});

  const { data } = CollectionQuery.useGetAll({
    page: pageOption.page,
    size: pageOption.size,
    ...filter,
  });

  return (
    <ul
      css={{
        width: '560px',
        maxWidth: '100%',
        maxHeight: '60vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        '> li': {
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '10px 8px 10px 12px',
          borderRadius: radius.md,
          transition: 'background-color 0.15s ease',
          ':hover': { background: color.grey50 },
        },
      }}
    >
      {data?.data.map((c: ICollection) => {
        const isAdded = collectionIds.includes(c.id);
        return (
          <li key={c.id}>
            <div css={{ flex: 1, minWidth: 0 }}>
              <p css={{ fontSize: 15, fontWeight: 600, color: color.text }}>
                {c.name}
              </p>
              <p css={{ marginTop: 3, fontSize: 12, color: color.textMuted }}>
                {COLLECTION_TYPE_LABEL[c.type] ?? '기본'}
                {c.title ? ` · ${c.title}` : ''}
              </p>
            </div>
            <UiComponent.Button
              color={isAdded ? 'background' : 'primary'}
              variant={isAdded ? 'contained' : 'border'}
              disabled={isAdded}
              onClick={() => handleSelect(c)}
              css={{ height: '36px', minWidth: '72px' }}
            >
              {isAdded ? '추가됨' : '선택'}
            </UiComponent.Button>
          </li>
        );
      })}
    </ul>
  );
}

export default CollectionModal;
